<script setup lang="ts">
import "leaflet/dist/leaflet.css";
import type { Branches } from "~/types/directus-collections.d.ts";

const props = defineProps<{
  branches: Branches[];
}>();

const mapEl = ref<HTMLDivElement | null>(null);

onMounted(async () => {
  const leaflet = (await import("leaflet")).default;

  const branchMap = ref<leaflet.Map | null>(null);
  // Fix default icon base path
  const icon = leaflet.icon({
    iconUrl: "/map-marker-custom.svg",
    iconSize: [16, 21],
    iconAnchor: [8, 0],
  });

  if (!mapEl.value) {
    console.warn("Leaflet map element not found");
    return;
  }

  branchMap.value = leaflet.map(mapEl.value, {
    center: [-42.17560998930404, 146.60608410768896],
    maxBounds: [
      [-44.3359, 143.3863],
      [-39.2197, 149.0662],
    ],
    zoom: 7,
    minZoom: 7,
    zoomControl: false,
  });

  leaflet
    .tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
      attribution:
        'Map data &copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors, <a href="https://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>',
    })
    .addTo(branchMap.value);

  if (props.branches.length) {
    props.branches.forEach((branch) => {
      if (!branch.location) return;

      const popupContent = `
        <div class="text-center space-y-3">
          <div class="text-lg font-semibold">${branch.title}</div>
          <div class="text-sm text-accentDark">${
            branch.description && branch.description.length > 200 ? branch.description.slice(0, 200) + "..." : branch.description
          }</div>
        </div>
      `;
      const latlng = leaflet.latLng(branch.location?.coordinates.reverse());
      if (latlng) {
        const marker = leaflet.marker(latlng, { icon }).addTo(toRaw(branchMap.value));
        marker.bindPopup(popupContent, {
          maxWidth: 250,
          className: "rounded-lg",
        });
      }
    });
  }
});
</script>

<template>
  <div id="map" ref="mapEl" class="relative z-0 aspect-[8/9] w-full bg-tertiary"></div>
</template>
